"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const roomCreateStore_1 = require("@/room/room_create/roomCreateStore");
const react_i18next_1 = require("react-i18next");
const useMediaQuery_1 = __importDefault(require("@mui/material/useMediaQuery"));
const FormControlLabel_1 = __importDefault(require("@mui/material/FormControlLabel"));
const Checkbox_1 = __importDefault(require("@mui/material/Checkbox"));
const wrapper_component_1 = require("@/room/room_create/wrapper_component");
const _1 = require(".");
function default_1() {
    const isEdit = (0, react_redux_1.useSelector)((state) => state.isEdit);
    const roomId = (0, react_redux_1.useSelector)((state) => state.roomData.id);
    const refundPolicyFetched = (0, react_redux_1.useSelector)((state) => state.refundPolicyFetched);
    const keepingRefundPolicy = (0, react_redux_1.useSelector)((state) => state.keepingRefundPolicy);
    (0, react_1.useEffect)(() => {
        if (!isEdit && roomId && !refundPolicyFetched)
            dispatch((0, roomCreateStore_1.getRefundPolicy)());
    }, [roomId]);
    const dispatch = (0, react_redux_1.useDispatch)();
    const maxWidth768 = (0, useMediaQuery_1.default)('(max-width:768px)');
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)(wrapper_component_1.MidSectionWrapper, Object.assign({ noGrid: true }, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "required_wrapper subtitle2" }, { children: [(0, jsx_runtime_1.jsx)("span", Object.assign({ className: "gray-80" }, { children: t('교환/환불 안내') })), (0, jsx_runtime_1.jsx)("span", Object.assign({ className: "error-main" }, { children: "*" }))] })), (0, jsx_runtime_1.jsxs)("div", Object.assign({ css: { display: 'flex', flexDirection: 'column', rowGap: maxWidth768 ? '10px' : '16px' } }, { children: [(0, jsx_runtime_1.jsx)(_1.RefundEditorTemplate, {}), (0, jsx_runtime_1.jsx)(_1.RefundEditor, {}), !isEdit && ((0, jsx_runtime_1.jsx)(FormControlLabel_1.default, { sx: {
                            height: '24px',
                            m: 0,
                            mt: '10px',
                            '.MuiCheckbox-root': { padding: '6px' },
                        }, control: (0, jsx_runtime_1.jsx)(Checkbox_1.default, { checked: keepingRefundPolicy, onChange: () => dispatch((0, roomCreateStore_1.setKeepingRefundPolicy)(!keepingRefundPolicy)) }), label: (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "body2 gray-80" }, { children: t('다음에도 사용') })) }))] }))] })));
}
exports.default = default_1;
